import React, { PureComponent } from 'react';

import { I18n } from 'components/translate';
import { PropTypes } from 'prop-types';

const DEFAULT_ARRAY = [];

export default class ChecklistSelectedItems extends PureComponent {
  static propTypes = {
    items: PropTypes.array,
    checklistId: PropTypes.string,
    selectedLimit: PropTypes.number,
    text: PropTypes.string
  };

  static defaultProps = {
    text: 'general.selected_items'
  };

  get items() {
    const { items } = this.props;

    return items || DEFAULT_ARRAY;
  }

  get amountChecked() {
    const items = this.items;

    return items.reduce((acc, cur) => acc + (cur.checked || 0), 0);
  }

  get total() {
    const { selectedLimit } = this.props;
    const items = this.items;

    return selectedLimit || items.length;
  }

  render() {
    const { text, checklistId } = this.props;

    return (
      <div
        className="checklist__item checklist__item__selected__items"
        key={`checklist__${checklistId}__item__selected__items`}
      >
        <I18n html label={text} />
        <I18n
          html
          label="pagination.amount_from_total"
          className="amount__from__total"
          data={{
            amount: this.amountChecked,
            total: this.total
          }}
        />
      </div>
    );
  }
}
